import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { PiInfo, PiPlus, PiMinus } from "react-icons/pi";
import { Link } from "react-router-dom";
import {
    Buttton,
    CustomDatePicker,
    Inputs,
    SelectO,
} from "../../../components";
import { useDispatch, useSelector } from "react-redux";
import { actionCommon, actionDoctor } from "../../../redux/actions";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import { useAlert, useToast } from "../../../contexts";

const AdditionalInformation = ({
    loginData,
    isEditVisible,
    getAdditionalInfoData,
    handleFormClick,
}) => {


    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { showAlert } = useAlert();
    const { showToast } = useToast();
    const [credentials, setCredentials] = useState({
        userGuid: loginData.userGuid,
        clinicGuid: "00000000-0000-0000-0000-000000000000",
        physicianServiceIds: [],
        ownPractice: true,
        practiceNumber: "",
        practiceDocument: {
            fileGuid: null,
            docName: null,
            docURL: null,
            isDeleted: false,
        },
        clinicName: "",
        clinicContact: "",
        clinicEmail: "",
        clinicAddress: "",
        city: "",
        state: "",
        zip: "",
        country: "",
        profileVerification: 0,
        educationModel: [
            {
                doctorEducationGuid: null,
                degreeTitle: "",
                collage: "",
                passingYear: null,
                verificationType: 0,
                educationCertificates: [
                    {
                        fileGuid: null,
                        docName: "",
                        docURL: "",
                        isDeleted: false,
                    },
                ],
            },
        ],
        experienceModel: [
            {
                doctorExperienceGuid: null,
                startDate: "",
                endDate: "",
                startDateYear: "",
                endDateYear: "",
                organizationName: "",
                description: "",
                isStillWorking: false,
                verificationType: 0
            },
        ],
        aboutClinic: "",
        fromTime: "",
        toTime: "",
        workDays: "",
        experience: "",
    });

    const [errors, setErrors] = useState({});

    useEffect(() => {
        dispatch(actionCommon.getPhysicianService(1));
    }, [dispatch]);

    const [educationUploadState, setEducationUploadState] = useState("initial");
    const [educationErrorMessage, setEducationErrorMessage] = useState("dfsdf");

    const [practiceLicenceUploadState, setPracticeLicenceUploadState] =
        useState("initial");
    const [practiceLicenceErrorMessage, setPracticeLicenceErrorMessage] =
        useState("dfsdf");

    const [openFrom, setOpenFrom] = useState();
    const [closedAt, setClosedAt] = useState();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCredentials((prevCredentials) => ({
            ...prevCredentials,
            [name]: value,
        }));

        if (name === "clinicName" && value.trim().length >= 2) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                clinicName: "", // Clear error when clinicName is valid
            }));
        }

        if (name === "aboutClinic" && value.trim().length >= 5) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                aboutClinic: "", // Clear error when aboutClinic is valid
            }));
        }

        if (name === "clinicEmail" && /\S+@\S+\.\S+/.test(value)) {
            setErrors((prevErrors) => {
                const { clinicEmail, ...rest } = prevErrors; // Remove clinicEmail error if valid
                return rest;
            });
        }

        if (name === "clinicAddress") {
            if (!value.trim()) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    clinicAddress: t("* Address is required"),
                }));
            } else if (value.trim().length < 5) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    clinicAddress: t("* Address must be at least 5 characters"),
                }));
            } else {
                setErrors((prevErrors) => {
                    const { clinicAddress, ...rest } = prevErrors; // Remove clinicAddress error if valid
                    return rest;
                });
            }
        }

        if (name === "city" && value.trim().length >= 2) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                city: "", // Clear error for city
            }));
        }

        // Remove error for state if it's valid
        if (name === "state" && value.trim().length >= 2) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                state: "", // Clear error for state
            }));
        }

        // Remove error for country if it's valid
        if (name === "country" && value.trim().length >= 2) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                country: "", // Clear error for country
            }));
        }
        if (name === "workDays" && value.replace(/\D/g, '')) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                country: "", // Clear error for country
            }));
        }


    };

    const handleEducationChange = (index, fieldName, value) => {
        setCredentials((prevState) => {
            const updatedEducationModel = [...prevState.educationModel];
            updatedEducationModel[index] = {
                ...updatedEducationModel[index],
                [fieldName]: value,
            };
            return {
                ...prevState,
                educationModel: updatedEducationModel,
            };
        });
    };

    const handleEducationFileChange = (educationIndex, FileList) => {
        if (!FileList || FileList.length === 0) return;

        const maxFileSize = 5 * 1024 * 1024; // 5 MB
        const supportedTypes = ["application/pdf", "image/jpeg", "image/png"];

        for (let i = 0; i < FileList.length; i++) {
            const file = FileList[i];


            if (!supportedTypes.includes(file.type)) {
                setEducationErrorMessage("File type not supported");
                setEducationUploadState("error");
                return;
            }


            if (file.size > maxFileSize) {
                setEducationErrorMessage(`File size exceeds ${5} MB.`);
                setEducationUploadState("error");
                return;
            }


            setEducationErrorMessage("");
            setEducationUploadState("uploading");

            const formData = new FormData();
            formData.append("file", file);


            dispatch(
                actionDoctor.addProfileCertificates(
                    formData,
                    2,
                    credentials.userGuid,
                    (error, response) => {
                        if (error) {
                            console.error(error);
                            setEducationErrorMessage("Failed to upload file");
                            setEducationUploadState("error");
                        } else if (response?.data?.result?.data) {
                            const uploadedFile = response.data.result.data;


                            const docName = uploadedFile.docName || file.name;
                            const docURL = uploadedFile.docURL || "";


                            setCredentials((prevState) => {
                                const updatedEducationModel = (
                                    prevState.educationModel || []
                                ).map((education, index) => {
                                    if (index === educationIndex) {
                                        const existingCertificates =
                                            education.educationCertificates || [];

                                        const updatedCertificates = [
                                            ...existingCertificates.filter(
                                                (cert) => cert.docName !== "" || cert.docURL !== ""
                                            ),
                                            {
                                                fileGuid: uploadedFile.fileGuid || null,
                                                docName,
                                                docURL,
                                                isDeleted: false,
                                            },
                                        ];

                                        return {
                                            ...education,
                                            educationCertificates: updatedCertificates,
                                        };
                                    }
                                    return education;
                                });

                                return {
                                    ...prevState,
                                    educationModel: updatedEducationModel,
                                };
                            });

                            setEducationUploadState("uploaded");
                        }
                    }
                )
            );
        }
    };

    const handlePracticeLicenceFileChange = (event) => {
        const file = event.target.files[0]; // Only handle the first file (single file upload)

        if (!file) return; // Exit if no file is selected

        const maxFileSize = 5 * 1024 * 1024; // 5 MB

        // Validate file type
        if (!["application/pdf", "image/jpeg", "image/png"].includes(file.type)) {
            setPracticeLicenceErrorMessage("File type not supported");
            setPracticeLicenceUploadState("error");
            return;
        }

        // Validate file size
        if (file.size > maxFileSize) {
            setPracticeLicenceErrorMessage(`File size exceeds ${5} MB.`);
            setPracticeLicenceUploadState("error");
            return;
        }

        // Process valid file
        setPracticeLicenceErrorMessage("");
        setPracticeLicenceUploadState("uploading");

        const formData = new FormData();
        formData.append("file", file);
        setTimeout(() => {
            dispatch(
                actionDoctor.addProfileCertificates(
                    formData,
                    3,
                    credentials.userGuid,
                    (error, response) => {
                        if (error) {
                            console.error(error);
                            setPracticeLicenceErrorMessage(
                                "Upload failed. Please try again."
                            );
                            setPracticeLicenceUploadState("error");
                        } else if (response) {
                            if (response?.data?.result?.data) {
                                const uploadedFile = response.data.result.data;

                                const docName = uploadedFile.docName || file.name;
                                const docURL = uploadedFile.docURL || "";

                                setCredentials((prevState) => ({
                                    ...prevState,
                                    practiceDocument: {
                                        fileGuid: null,
                                        docName: docName || null,
                                        docURL: docURL || null,
                                        isDeleted: false,
                                    },
                                }));

                                setPracticeLicenceUploadState("uploaded");
                            }
                        }
                    }
                )
            );
        }, 2000);
    };

    const handleDelete = () => {
        // setFile(null);
        // setUploadState("initial");
        setEducationErrorMessage("");
    };

    const removeEducation = (index) => {
        setCredentials((prevState) => {
            const updatedEducationModel = [
                ...prevState.educationModel.slice(0, index),
                ...prevState.educationModel.slice(index + 1),
            ];
            return {
                ...prevState,
                educationModel: updatedEducationModel,
            };
        });
    };

    const addEducation = () => {
        setEducationUploadState("initial");
        setCredentials((prevState) => ({
            ...prevState,
            educationModel: [
                ...prevState.educationModel,
                {
                    doctorEducationGuid: null,
                    degreeTitle: "",
                    collage: "",
                    passingYear: null,
                    educationCertificates: [
                        {
                            fileGuid: "",
                            docName: "",
                            docURL: "",
                            isDeleted: false,
                        },
                    ],
                },
            ],
        }));
    };

    const handleChange1 = (docIndex, e) => {
        const { name, value } = e.target;

        setCredentials((prevState) => {
            const updatedExperiences = prevState.experienceModel.map(
                (experience, index) =>
                    index === docIndex ? { ...experience, [name]: value } : experience
            );

            return { ...prevState, experienceModel: updatedExperiences };
        });
    };

    const addExperience = () => {
        setCredentials((prevState) => ({
            ...prevState,
            experienceModel: [
                ...prevState.experienceModel,
                {
                    doctorExperienceGuid: null,
                    startDate: null,
                    endDate: null,
                    startDateYear: null,
                    endDateYear: null,
                    organizationName: "",
                    description: "",
                    isStillWorking: false,
                },
            ],
        }));
    };

    const handleSelectChange4 = (name, selected) => {
        const value = selected
            ? Array.isArray(selected)
                ? selected.map((option) => option.value)
                : selected.value
            : "";
        setCredentials((prevCredentials) => ({
            ...prevCredentials,
            [name]: value,
        }));
        if (name === "physicianServiceIds" && selected.length > 0) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                physicianServiceIds: "",
            }));
        }
        setSelectedPhysicianServices(selected);
    };

    const handleOpenFromChange = (time) => {
        if (time) {
            const formattedTime = time.toISOString();


            setOpenFrom(time);


            setCredentials((prevState) => ({
                ...prevState,
                fromTime: formattedTime,
            }));


            setErrors((prevErrors) => ({
                ...prevErrors,
                openFrom: "",
            }));


            if (closedAt && new Date(closedAt) <= new Date(time)) {
                setClosedAt(null);
                setCredentials((prevState) => ({
                    ...prevState,
                    toTime: "",
                }));
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    closedAt: t("* Closing time must be after opening time"),
                }));
            }
        }
    };

    const handleClosedAtChange = (time) => {
        if (time) {
            const formattedTime = time.toISOString();


            if (openFrom && new Date(time) <= new Date(openFrom)) {
                showAlert("danger", "Closing time must be after opening time", `${t("Error")} !`);

            } else {

                setClosedAt(time);


                setCredentials((prevState) => ({
                    ...prevState,
                    toTime: formattedTime,
                }));


                setErrors((prevErrors) => ({
                    ...prevErrors,
                    closedAt: "",
                }));
            }
        }
    };

    const handleDateChange = (docIndex, date, fieldName) => {
        setCredentials((prevState) => {
            const updatedExperienceModel = prevState.experienceModel.map(
                (exp, index) =>
                    index === docIndex
                        ? {
                            ...exp,
                            [fieldName]: date,
                            isStillWorking:
                                fieldName === "endDate" ? false : exp.isStillWorking,
                        }
                        : exp
            );

            return {
                ...prevState,
                experienceModel: updatedExperienceModel,
            };
        });
    };

    const handleCheckboxChange = (docIndex, e) => {
        const { checked } = e.target;

        setCredentials((prevState) => {
            const updatedExperienceModel = prevState.experienceModel.map(
                (exp, index) =>
                    index === docIndex
                        ? {
                            ...exp,
                            isStillWorking: checked,
                            endDate: checked ? null : exp.endDate,
                        }
                        : exp
            );

            return {
                ...prevState,
                experienceModel: updatedExperienceModel,
            };
        });
    };

    const onSendForVerification = () => {
        let newErrors = {};
        if (credentials.physicianServiceIds.length === 0) {
            newErrors.physicianServiceIds = t(
                "please select at least one physician service"
            );
        }

        if (credentials.ownPractice) {

            if (!credentials.practiceNumber) {
                newErrors.practiceNumber = t("Practice number is required");
            } else if (credentials.practiceNumber.trim().length < 5) {
                newErrors.practiceNumber = t("Practice number must be at least 5 characters");
            }
            if (!credentials.practiceDocument || !credentials.practiceDocument.docName) {
                newErrors.practiceDocument = t("Practice document is required");
            }
            if (!credentials.clinicName) {
                newErrors.clinicName = t("* Practice document is required");
            }

            if (!credentials.aboutClinic || credentials.aboutClinic.trim().length < 5) {
                newErrors.aboutClinic = t("* Short description about the practice is required and should be at least 5 characters.");
            }

            if (!credentials.clinicEmail) {
                newErrors.clinicEmail = t("* Email address is required");
            } else if (!/\S+@\S+\.\S+/.test(credentials.clinicEmail)) {
                newErrors.clinicEmail = t("* Email address must be valid");
            }

            if (!credentials.clinicContact) {
                newErrors.clinicContact = t("errors.phone.error1");
            } else if (!/^\d+$/.test(credentials.clinicContact)) {
                newErrors.clinicContact = t("errors.phone.error2");
            }

            if (!credentials.clinicAddress) {
                newErrors.clinicAddress = t("* Address is required");
            } else if (credentials.clinicAddress.trim().length < 5) {
                newErrors.clinicAddress = t("* Address must be at least 5 characters");
            }
            if (!credentials.zip) {
                newErrors.zip = t("* Zip code is required");
            } else if (!/^\d+$/.test(credentials.zip)) {
                newErrors.zip = t("* Zip code must be numeric");
            }
            if (!credentials.city) {
                newErrors.city = t("* City is required");
            } else if (credentials.city.trim().length < 2) {
                newErrors.city = t("* City must be at least 2 characters");
            }

            if (!credentials.state) {
                newErrors.state = t("* State/District is required");
            } else if (credentials.state.trim().length < 2) {
                newErrors.state = t("* State/District must be at least 2 characters");
            }

            if (!credentials.country) {
                newErrors.country = t("* Country is required");
            } else if (credentials.country.trim().length < 2) {
                newErrors.country = t("* Country must be at least 2 characters");
            }

            if (!credentials.fromTime) {
                newErrors.openFrom = t("* Opening time is required");
            }

            if (!credentials.toTime) {
                newErrors.closedAt = t("* Closing time is required");
            } else if (credentials.fromTime && new Date(credentials.toTime) <= new Date(credentials.fromTime)) {
                newErrors.closedAt = t("* Closing time must be after opening time");
            }


            if (!credentials.workDays) {
                newErrors.workDays = t("*required");
            } else if (!/^\d+$/.test(credentials.workDays)) { // Ensures only digits
                newErrors.workDays = t("*only number");
            } else if (parseInt(credentials.workDays) < 1 || parseInt(credentials.workDays) > 7) {
                newErrors.workDays = t("*only between 1 and 7");
            }

            if (!credentials.experience) {
                newErrors.experience = t("*year is required");
            } else if (!/^\d{4}$/.test(credentials.experience)) {  // Ensures 4 digits
                newErrors.experience = t("*Invalid year format. Please enter a valid 4-digit year");
            } else if (parseInt(credentials.experience) > new Date().getFullYear()) {
                newErrors.experience = t("* Year cannot be in the future");
            }

        }

        credentials.educationModel.forEach((education, index) => {
            if (!education.degreeTitle || education.degreeTitle.trim().length === 0) {
                newErrors[`educationModel[${index}].degreeTitle`] = t("* Degree title is required");
            }
            if (!education.collage || education.collage.trim().length === 0) {
                newErrors[`educationModel[${index}].collage`] = t("* University/College name is required");
            }
            if (!education.passingYear) {
                newErrors[`educationModel[${index}].passingYear`] = t("* Graduation year is required");
            } else if (!/^\d{4}$/.test(education.passingYear)) {
                newErrors[`educationModel[${index}].passingYear`] = t("* Graduation year must be a valid 4-digit year");
            } else if (parseInt(education.passingYear) > new Date().getFullYear()) {
                newErrors[`educationModel[${index}].passingYear`] = t("* Graduation year cannot be in the future");
            }
            if (!education.educationCertificates || education.educationCertificates.length === 0) {
                newErrors[`educationModel[${index}].educationCertificates`] = t("* At least one education certificate is required");
            } else {
                education.educationCertificates.forEach((certificate, certIndex) => {
                    if (!certificate.docName || certificate.docName.trim().length === 0) {
                        newErrors[`educationModel[${index}].educationCertificates[${certIndex}].docName`] = t("*At least one education certificate is required");
                    }
                });
            }
        });

        credentials.experienceModel.forEach((experience, index) => {
            if (!experience.organizationName || experience.organizationName.trim().length === 0) {
                newErrors[`experienceModel[${index}].organizationName`] = t("* Organization name is required");
            }
            if (!experience.startDate) {
                newErrors[`experienceModel[${index}].startDate`] = t("* Start date is required");
            }
            if (!experience.endDate && !experience.isStillWorking) {
                newErrors[`experienceModel[${index}].endDate`] = t("*required");
                showAlert("danger", t("* End date is required, or check 'Current Work Place'"), `${t("Error")} !`);
            }
            if (experience.startDate && experience.endDate && new Date(experience.endDate) < new Date(experience.startDate)) {
                newErrors[`experienceModel[${index}].endDate`] = t("* required");
                showAlert("danger", t("* End date cannot be before start date"), `${t("Error")} !`);
            }
            if (!experience.description || experience.description.trim().length < 5) {
                newErrors[`experienceModel[${index}].description`] = t("* Description is required and should be at least 5 characters");
            }
        });

        setErrors(newErrors);

        dispatch(
            actionDoctor.saveAdditionalInfo(credentials, (error, response) => {
                if (error) {
                    if (error.data) {
                        if (error.data.statusCode === 400) {
                            if (error.data.error && error.data.error.ValidationErrors) {
                                error.data.error.ValidationErrors.forEach((validationError) => {
                                    console.error(
                                        `${t("Field")}: ${validationError.Field} - ${t(
                                            "Message"
                                        )}: ${validationError.Message}`
                                    );

                                    showAlert(
                                        "danger",
                                        validationError.Message,
                                        `${t("Error")} : ${validationError.Field}`
                                    );
                                });
                            } else {
                                showAlert(
                                    "danger",
                                    t("Invalid_credentials"),
                                    `${t("Error")} !`
                                );
                            }
                        } else {
                            showAlert("danger", t("unexpected_error"), `${t("Error")} !`);
                        }
                    }
                } else if (response) {
                    if (response.status === 200) {
                        showToast(
                            "Success !",
                            "Your personal information has been updated successfully.",
                            5000,
                            true,
                            "top-end toast-success"
                        );

                        dispatch(actionDoctor.getAdditionalInfo(loginData.userGuid));
                        dispatch(actionDoctor.getProfileInfo(loginData.userGuid));
                    }
                }
            })
        );

    };

    // useEffect(() => {
    //     dispatch(actionCommon.getPhysicianService(1));
    // }, [dispatch]);

    const getPhysicianServiceData = useSelector(
        (state) => state.common.getPhysicianServiceData?.data
    );

    const [options4, setOptions4] = useState([]);
    const [selectedPhysicianServices, setSelectedPhysicianServices] = useState(
        []
    );

    useEffect(() => {
        if (getPhysicianServiceData) {
            const newOption = getPhysicianServiceData.result.map((item) => ({
                value: item.isPhysicianServiceId,
                label: item.physicianServiceName,
            }));
            setOptions4(newOption);
        }
    }, [getPhysicianServiceData]);

    useEffect(() => {
        if (getAdditionalInfoData) {
            const data = getAdditionalInfoData.result;

            if (data.clinicGuid && data.clinicGuid !== "00000000-0000-0000-0000-000000000000") {
                setCredentials((prevCredentials) => ({
                    ...prevCredentials,
                    clinicGuid: data.clinicGuid || null,
                    practiceNumber: data.practiceNumber || "",
                    clinicName: data.clinicName || "",
                    aboutClinic: data.aboutClinic || "",
                    clinicEmail: data.clinicEmail || "",
                    clinicContact: data.clinicContact || "",
                    practiceDocument: {
                        ...prevCredentials.practiceDocument,
                        fileGuid: data.practiceDocument.fileGuid || null,
                        docName: data.practiceDocument.docName || null,
                        docURL: data.practiceDocument.docURL || null,
                    },
                    clinicAddress: data.clinicAddress || "",
                    zip: data.zip || "",
                    city: data.city || "",
                    state: data.state || "",
                    country: data.country || "",
                    workDays: data.workDays || "",
                    experience: data.experience || "",
                    educationModel: data.educationModel || [],
                    experienceModel: data.experienceModel || [],
                    fromTime: data.fromTime || "",
                    toTime: data.toTime || "",
                }));

                if (data.physicianServiceIds) {
                    const physicianServices = options4.filter((option) =>
                        data.physicianServiceIds.includes(option.value)
                    );
                    setSelectedPhysicianServices(physicianServices);
                    setCredentials((prev) => ({
                        ...prev,
                        physicianServiceIds: data.physicianServiceIds,
                    }));
                }

                if (data.fromTime) {
                    const fromDate = new Date(data.fromTime);
                    if (!isNaN(fromDate)) {
                        setOpenFrom(fromDate);
                    } else {
                        console.error("Invalid fromTime value:", data.fromTime);
                    }
                }

                if (data.toTime) {
                    const toDate = new Date(data.toTime);
                    if (!isNaN(toDate)) {
                        setClosedAt(toDate);
                    } else {
                        console.error("Invalid toTime value:", data.toTime);
                    }
                }
            }
        }
    }, [getAdditionalInfoData, options4]);



    return (
        <>
            <Form className="profile-form additional-form" onClick={handleFormClick}>
                <Row className="pro-row pro-row1">
                    <Col>
                        <p className="exado-title-six">
                            <PiInfo className="ai-piInfo" />
                            {t("profile_page.additional_information.information")}{" "}
                            <Link className="ai-info-link">medical.services@exado.eu</Link>
                        </p>
                    </Col>
                </Row>
                <Row className="pro-row pro-row2">
                    <Col >
                        <Form.Label className="exado-title-six">
                            {t("Select")} {t("Physician")} {t("Services")}
                        </Form.Label>

                        <SelectO.SelectO
                            options={options4}
                            onChange={(selected) =>
                                handleSelectChange4("physicianServiceIds", selected)
                            }
                            isMulti={true}
                            isSearchable={true}
                            name="physicianServiceIds"
                            value={selectedPhysicianServices}
                            className={`select1 ${errors.physicianServiceIds ? "select-border-error" : ""
                                }`}
                            placeholder={
                                t("Select") + " " + t("Physician") + " " + t("Services")
                            }
                            isDisabled={!isEditVisible}
                        />
                        {errors.physicianServiceIds && (
                            <Form.Text className="error-message noVerify">
                                {errors.physicianServiceIds}
                            </Form.Text>
                        )}
                    </Col>
                    <Col className="pro-col">
                        <Form.Label className="exado-title-six">
                            {t("Owner_of_Practice")} ?
                        </Form.Label>
                        <Row style={{ padding: "1.6rem 1.6rem 1.6rem 0" }}>
                            <Col className="form-grp-radio-col form-grp-radio-add-col">
                                <Inputs.CheckRadioInput
                                    type="radio"
                                    label={t("profile_page.owns_practice_yes")}
                                    name="ownPractice"
                                    className="form-grp-radio"
                                    checked={credentials.ownPractice === true}
                                    onChange={() =>
                                        setCredentials({ ...credentials, ownPractice: true })
                                    }
                                    value={true}
                                    disabled={!isEditVisible}
                                />
                                <Inputs.CheckRadioInput
                                    type="radio"
                                    label={t("profile_page.owns_practice_no")}
                                    name="ownPractice"
                                    value={false}
                                    className="form-grp-radio form-grp-add-radio"
                                    checked={credentials.ownPractice === false}
                                    onChange={() =>
                                        setCredentials({ ...credentials, ownPractice: false })
                                    }
                                    disabled={!isEditVisible}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
                {credentials.ownPractice && (
                    <>
                        <Row className="pro-row pro-row3">
                            <Col>
                                <Form.Label className="exado-title-six">
                                    {t("Practise_Number")}
                                </Form.Label>
                                <Row>
                                    <Inputs.FormInputs
                                        name="practiceNumber"
                                        value={credentials.practiceNumber}
                                        onChange={(e) => {
                                            handleChange(e);

                                            if (e.target.value.trim().length >= 5) {
                                                setErrors((prevErrors) => ({
                                                    ...prevErrors,
                                                    practiceNumber: "",
                                                }));
                                            }
                                        }}

                                        grpClassname={`form-group ${errors.practiceNumber ? "form-group-error" : ""
                                            }`}
                                        disabled={!isEditVisible}
                                    />

                                    {errors.practiceNumber && (
                                        <Form.Text className="error-message noVerify">
                                            {errors.practiceNumber}
                                        </Form.Text>
                                    )}
                                </Row>
                            </Col>
                            <Col md={6}></Col>
                        </Row>
                        <Row className="pro-row pro-row4">
                            <Col className="add-col" md={6}>
                                <Form.Label className="exado-title-six">
                                    {t("Practice_Licence_Document")}
                                </Form.Label>
                                <Row className="add-col-row position-relative">
                                    <Inputs.DocumentUpload
                                        htmlFor="practiseLicenceFileUpload"
                                        intialTxt={{
                                            udHeading: "UPLOAD FILE",
                                            udSubHeading: "PDF, JPEG, or PNG less than 5 GB",
                                        }}
                                        uploadingTxt={{
                                            udHeading: "Uploading...",
                                        }}
                                        uploadedTxt={{
                                            udHeading: "UPLOAD FILE",
                                            udSubHeading: "Uploaded",
                                        }}
                                        errorTxt={{
                                            udHeading: "UPLOAD FILE",
                                        }}
                                        uploadState={practiceLicenceUploadState}
                                        onChange={(event) => {
                                            handlePracticeLicenceFileChange(event);

                                            if (event.target.files && event.target.files.length > 0) {
                                                setErrors((prevErrors) => ({
                                                    ...prevErrors,
                                                    practiceDocument: "",
                                                }));
                                            }
                                        }}
                                        className={`document-upload ${errors.practiceDocument ? 'document-upload-error' : ''}`}
                                        errorMessage={practiceLicenceErrorMessage}
                                        multiple={false}
                                    />
                                    {errors.practiceDocument && (
                                        <Form.Text className="error-message noVerify">
                                            {errors.practiceDocument}
                                        </Form.Text>
                                    )}
                                    <div className="form-upload-file-lblk">
                                        <Link
                                            to={credentials.practiceDocument.docURL}
                                            target="_blank"
                                            className="form-upload-file-link"
                                        >
                                            {credentials.practiceDocument.docName}
                                        </Link>
                                    </div>
                                </Row>
                            </Col>
                        </Row>
                        <Row className="pro-row pro-row5">
                            <Form.Label className="exado-title-six">
                                {t("Practise_Information")}
                            </Form.Label>
                            <Col md={12}>
                                <Row>
                                    <Inputs.FormInputs
                                        label={
                                            errors.clinicName ? (
                                                <span className="error-message">
                                                    {" "}
                                                    {errors.clinicName}
                                                </span>
                                            ) : (
                                                t("profile_page.additional_information.Practise_Full_Name")
                                            )
                                        }
                                        value={credentials.clinicName}
                                        name="clinicName"
                                        onChange={handleChange}
                                        grpClassname={`form-group ${errors.clinicName ? "form-group-error" : ""}`}
                                        disabled={!isEditVisible}
                                    />

                                </Row>
                            </Col>
                            <Col md={12} className="pro-col">
                                <Row>
                                    <Inputs.FormInputs
                                        type="textarea"
                                        placeholder={t(
                                            "profile_page.additional_information.Write_text_here"
                                        )}
                                        label={
                                            errors.aboutClinic ? (
                                                <span className="error-message">
                                                    {errors.aboutClinic}
                                                </span>
                                            ) : (
                                                t("profile_page.additional_information.Short_Description_About_Practise")
                                            )
                                        }
                                        name="aboutClinic"
                                        value={credentials.aboutClinic}
                                        onChange={handleChange}
                                        grpClassname={`form-group ${errors.aboutClinic ? "form-group-error" : ""}`}
                                        disabled={!isEditVisible}
                                    />
                                </Row>
                            </Col>
                        </Row>
                        <Row className="pro-row pro-row6">
                            <Col md={12} className="pro-col">
                                <Form.Label className="exado-title-six">
                                    {t(
                                        "profile_page.additional_information.Practise_Contact_Information"
                                    )}
                                </Form.Label>
                            </Col>
                            <Col md={6} className="pro-col">
                                <Row>
                                    <Inputs.FormInputs
                                        name="clinicEmail"
                                        value={credentials.clinicEmail}
                                        onChange={handleChange}

                                        label={
                                            errors.clinicEmail ? (
                                                <span className="error-message">{errors.clinicEmail}</span>
                                            ) : (
                                                t("email") + " " + t("Address")
                                            )
                                        }
                                        grpClassname={`form-group ${errors.clinicEmail ? "form-group-error" : ""}`}
                                        disabled={!isEditVisible}
                                    />
                                </Row>
                            </Col>
                            <Col md={6} className="pro-col">
                                <Row>
                                    <Inputs.FormInputs
                                        name="clinicContact"
                                        value={credentials.clinicContact}
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/\D/g, '');
                                            setCredentials({
                                                ...credentials,
                                                clinicContact: value,
                                            });
                                        }}

                                        label={
                                            errors.clinicContact ? (
                                                <span className="error-message">{errors.clinicContact}</span>
                                            ) : (
                                                t("phone_number")
                                            )
                                        }
                                        grpClassname={`form-group ${errors.clinicContact ? "form-group-error" : ""}`}
                                        disabled={!isEditVisible}
                                    />
                                </Row>
                            </Col>
                            <Col md={6} className="pro-col">
                                <Row>
                                    <Inputs.FormInputs
                                        name="clinicAddress"
                                        value={credentials.clinicAddress}
                                        onChange={handleChange}

                                        label={
                                            errors.clinicAddress ? (
                                                <span className="error-message">{errors.clinicAddress}</span>
                                            ) : (
                                                t("profile_page.additional_information.Street_Name_and_Door_Number")
                                            )
                                        }
                                        grpClassname={`form-group ${errors.clinicAddress ? "form-group-error" : ""}`}
                                        disabled={!isEditVisible}
                                    />
                                </Row>
                            </Col>
                            <Col md={6} className="pro-col">
                                <Row>
                                    <Inputs.FormInputs
                                        name="zip"
                                        value={credentials.zip}
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/\D/g, '');
                                            setCredentials({
                                                ...credentials,
                                                zip: value,
                                            });


                                            if (!value) {
                                                setErrors((prevErrors) => ({
                                                    ...prevErrors,
                                                    zip: t("* Zip code is required"),
                                                }));
                                            } else {
                                                setErrors((prevErrors) => {
                                                    const { zip, ...rest } = prevErrors;
                                                    return rest;
                                                });
                                            }
                                        }}
                                        maxLength={6}
                                        label={
                                            errors.zip ? (
                                                <span className="error-message">{errors.zip}</span>
                                            ) : (
                                                t("Post_Code")
                                            )
                                        }
                                        grpClassname={`form-group ${errors.zip ? "form-group-error" : ""}`}
                                        disabled={!isEditVisible}
                                    />
                                </Row>
                            </Col>
                            <Col md={4} className="pro-col">
                                <Row>
                                    <Inputs.FormInputs
                                        name="city"
                                        value={credentials.city}
                                        onChange={handleChange}
                                        label={
                                            errors.city ? (
                                                <span className="error-message">{errors.city}</span>
                                            ) : (
                                                t("City")
                                            )
                                        }
                                        grpClassname={`form-group ${errors.city ? "form-group-error" : ""}`}
                                        disabled={!isEditVisible}
                                    />
                                </Row>
                            </Col>
                            <Col md={4} className="pro-col">
                                <Row>
                                    <Inputs.FormInputs
                                        name="state"
                                        value={credentials.state}
                                        onChange={handleChange}
                                        label={
                                            errors.state ? (
                                                <span className="error-message">{errors.state}</span>
                                            ) : (
                                                t("District") + " " + t("or") + " " + t("State")
                                            )
                                        }
                                        grpClassname={`form-group ${errors.state ? "form-group-error" : ""}`}
                                        disabled={!isEditVisible}
                                    />
                                </Row>
                            </Col>
                            <Col md={4} className="pro-col">
                                <Row>
                                    <Inputs.FormInputs
                                        name="country"
                                        value={credentials.country}
                                        onChange={handleChange}
                                        label={
                                            errors.country ? (
                                                <span className="error-message">{errors.country}</span>
                                            ) : (
                                                t("Country")
                                            )
                                        }
                                        grpClassname={`form-group ${errors.country ? "form-group-error" : ""}`}
                                        disabled={!isEditVisible}
                                    />
                                </Row>
                            </Col>
                        </Row>
                        <Row className="pro-row pro-row7">
                            <Form.Label className="exado-title-six">
                                {t(
                                    "profile_page.additional_information.Practise_Opening_Information"
                                )}
                            </Form.Label>
                            <Col lg={3} md={4} className="pro-col">
                                <Row>
                                    <Col className="gy-col">
                                        <fieldset className={`frm-fieldset custom-date-picker custom-time-picker ${errors.openFrom ? "error-date" : ""}`}>
                                            <legend className="frm-legend">
                                                {errors.openFrom ? (
                                                    <span className="error-message">{errors.openFrom}</span>
                                                ) : (
                                                    t("profile_page.additional_information.Open_From")
                                                )}
                                            </legend>
                                            <CustomDatePicker.CustomTimePicker
                                                selected={openFrom}
                                                onChange={handleOpenFromChange}
                                                timeIntervals={15}
                                                placeholderText="Pick a time"
                                                className="customDatePicker customTimePicker"
                                                timeCaption="Select Time"
                                                disabled={!isEditVisible}
                                                showTimeSelect={true}
                                                showTimeSelectOnly={true}
                                            />
                                        </fieldset>
                                    </Col>
                                </Row>
                            </Col>
                            <Col lg={3} md={4} className="pro-col">
                                <Row>
                                    <Col className="gy-col">
                                        <fieldset className={`frm-fieldset custom-date-picker custom-time-picker ${errors.closedAt ? "error-date" : ""}`}>
                                            <legend className="frm-legend">
                                                {errors.closedAt ? (
                                                    <span className="error-message">{errors.closedAt}</span>
                                                ) : (
                                                    t("profile_page.additional_information.Closed_At")
                                                )}
                                            </legend>
                                            <CustomDatePicker.CustomTimePicker
                                                selected={closedAt}
                                                onChange={handleClosedAtChange}
                                                timeIntervals={15}
                                                placeholderText="Pick a time"
                                                className="customDatePicker customTimePicker"
                                                timeCaption="Select Time"
                                                disabled={!isEditVisible}
                                                showTimeSelect={true}
                                                showTimeSelectOnly={true}
                                            />
                                        </fieldset>
                                    </Col>
                                </Row>
                            </Col>
                            <Col lg={3} md={4} className="pro-col">
                                <Row>
                                    <Inputs.FormInputs
                                        name="workDays"
                                        value={credentials.workDays}
                                        maxLength={1}
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/\D/g, '');

                                            setCredentials({
                                                ...credentials,
                                                workDays: value,
                                            });


                                            if (value < 1 || value > 7) {
                                                showAlert("danger", "please enter number between 1 and 7", `${t("Error")} !`);
                                                setErrors((prevErrors) => ({
                                                    ...prevErrors,
                                                    workDays: t("* Opening Days per Week"),
                                                }));
                                            } else {
                                                setErrors((prevErrors) => {
                                                    const { workDays, ...rest } = prevErrors;
                                                    return rest;
                                                });
                                            }
                                        }}
                                        placeholder={t(
                                            "profile_page.additional_information.Type_a_number"
                                        )}
                                        label={errors.workDays ? (
                                            <span className="error-message">{errors.workDays}</span>
                                        ) : (
                                            t("profile_page.additional_information.Opening_Days_per_Week")
                                        )}
                                        grpClassname={`form-group ${errors.workDays ? "form-group-error" : ""}`}
                                        disabled={!isEditVisible}
                                    />
                                </Row>
                            </Col>
                            <Col lg={3} md={4} className="pro-col">
                                <Row>
                                    <Inputs.FormInputs
                                        name="experience"
                                        value={credentials.experience}
                                        maxLength={4}
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/\D/g, '');

                                            setCredentials({
                                                ...credentials,
                                                experience: value,
                                            });


                                            const currentYear = new Date().getFullYear();


                                            if (value.length !== 4) {
                                                setErrors((prevErrors) => ({
                                                    ...prevErrors,
                                                    experience: t("*"),
                                                }));
                                                showAlert("danger", t("* Please enter a valid 4-digit year"), `${t("Error")} !`);
                                            } else if (parseInt(value) > currentYear) {
                                                setErrors((prevErrors) => ({
                                                    ...prevErrors,
                                                    experience: t("*"),
                                                }));
                                                showAlert("danger", t("* Year cannot be in the future"), `${t("Error")} !`);
                                            } else {
                                                setErrors((prevErrors) => {
                                                    const { experience, ...rest } = prevErrors;
                                                    return rest;
                                                });
                                            }
                                        }}
                                        placeholder="YYYY"
                                        label={errors.experience ? (
                                            <span className="error-message">{errors.experience}</span>
                                        ) : (
                                            t("profile_page.additional_information.Practise_Opening_Year")
                                        )}
                                        grpClassname={`form-group ${errors.experience ? "form-group-error" : ""}`}
                                        disabled={!isEditVisible}
                                    />
                                </Row>
                            </Col>
                        </Row>
                    </>
                )}

                <Row className="pro-row pro-row8">
                    <Col md={12} className="pro-col">
                        <Form.Label className="exado-title-six">
                            {t("Education")}
                        </Form.Label>
                    </Col>

                    {credentials.educationModel?.map((education, index) => {
                        return (
                            <React.Fragment key={index}>
                                <Col md={4} className="pro-col">
                                    <Row>
                                        <Inputs.FormInputs
                                            name="degreeTitle"

                                            label={
                                                errors[`educationModel[${index}].degreeTitle`] ? (
                                                    <span className="error-message">
                                                        {errors[`educationModel[${index}].degreeTitle`]}
                                                    </span>
                                                ) : (
                                                    t("Degree_Title")
                                                )
                                            }
                                            grpClassname={`form-group ${errors[`educationModel[${index}].degreeTitle`] ? "form-group-error" : ""
                                                }`}
                                            value={education.degreeTitle}
                                            disabled={!isEditVisible}
                                            onChange={(e) =>
                                                handleEducationChange(
                                                    index,
                                                    "degreeTitle",
                                                    e.target.value
                                                )
                                            }
                                        />
                                    </Row>
                                </Col>
                                <Col md={4} className="pro-col">
                                    <Row>
                                        <Inputs.FormInputs
                                            name="collage"
                                            label={
                                                errors[`educationModel[${index}].collage`] ? (
                                                    <span className="error-message">
                                                        {errors[`educationModel[${index}].collage`]}
                                                    </span>
                                                ) : (
                                                    t("University")
                                                )
                                            }
                                            grpClassname={`form-group ${errors[`educationModel[${index}].collage`] ? "form-group-error" : ""
                                                }`}
                                            value={education.collage}
                                            disabled={!isEditVisible}
                                            onChange={(e) =>
                                                handleEducationChange(index, "collage", e.target.value)
                                            }
                                        />
                                    </Row>
                                </Col>
                                <Col md={4} className="pro-col">
                                    <Row className="h-100">
                                        <Inputs.FormInputs
                                            name="passingYear"
                                            placeholder="YYYY"
                                            label={
                                                errors[`educationModel[${index}].passingYear`] ? (
                                                    <span className="error-message">
                                                        {errors[`educationModel[${index}].passingYear`]}
                                                    </span>
                                                ) : (
                                                    t("Graduation_Year")
                                                )
                                            }
                                            grpClassname={`form-group ${errors[`educationModel[${index}].passingYear`] ? "form-group-error" : ""
                                                }`}
                                            value={education.passingYear}
                                            disabled={!isEditVisible}
                                            onChange={(e) =>
                                                handleEducationChange(
                                                    index,
                                                    "passingYear",
                                                    e.target.value
                                                )
                                            }
                                        />
                                    </Row>
                                </Col>
                                <Col md={6} className="pro-col">
                                    <Inputs.DocumentUpload
                                        htmlFor={`educationFileUpload-${index}`}
                                        intialTxt={{
                                            udHeading: "UPLOAD FILE",
                                            udSubHeading: "PDF, JPEG, or PNG less than 5 GB",
                                        }}
                                        uploadingTxt={{
                                            udHeading: "Uploading...",
                                        }}
                                        uploadedTxt={{
                                            udHeading: "UPLOAD FILE",
                                            udSubHeading: "Uploaded",
                                        }}
                                        errorTxt={{
                                            udHeading: "UPLOAD FILE",
                                        }}
                                        className={`document-upload ${education.educationCertificates.some((certificate, certIndex) =>
                                            errors[`educationModel[${index}].educationCertificates[${certIndex}].docName`]
                                        ) ? 'document-upload-error' : ''
                                            }`}

                                        multiple={true}
                                        onChange={(e) =>
                                            handleEducationFileChange(index, e.target.files)
                                        }
                                    />
                                    {education.educationCertificates?.map((certificate, certIndex) => (
                                        errors[`educationModel[${index}].educationCertificates[${certIndex}].docName`] && (
                                            <Form.Text key={certIndex} className="error-message noVerify">
                                                {errors[`educationModel[${index}].educationCertificates[${certIndex}].docName`]}
                                            </Form.Text>
                                        )
                                    ))}
                                    <div className="form-upload-file-lblk1">
                                        {education.educationCertificates?.map(
                                            (certificate, certIndex) => (
                                                <Link
                                                    key={certIndex}
                                                    to={certificate.docURL}
                                                    target="_blank"
                                                    className="form-upload-file-link"
                                                >
                                                    {certificate.docName}
                                                </Link>
                                            )
                                        )}
                                    </div>
                                </Col>
                                <Col
                                    md={6}
                                    className="pro-col d-flex justify-content-end align-items-center"
                                >
                                    <Buttton.Buttton
                                        type="button"
                                        onClick={() => removeEducation(index)}
                                        children={
                                            <>
                                                <PiMinus className="add-icon" /> REMOVE
                                            </>
                                        }
                                        className="transparent"
                                    />
                                </Col>
                            </React.Fragment>
                        );
                    })}

                    <Col className="pro-col">
                        <Buttton.Buttton
                            type="button"
                            onClick={addEducation}
                            children={
                                <>
                                    {t("ADD_MORE")} <PiPlus className="add-icon" />
                                </>
                            }
                            className="transparent"
                        />
                    </Col>
                </Row>
                <Row className="pro-row pro-row9">
                    <Col className="pro-col  exp-col">
                        <Form.Label className="exado-title-six">
                            {t("profile_page.additional_information.work_experience")}
                        </Form.Label>
                    </Col>
                    {credentials.experienceModel?.map((experience, index) => (
                        <Col className="pro-col exp-col" md={12} key={index}>
                            <Row>
                                <Col md={6} className="pro-col">
                                    <Row>
                                        <Inputs.FormInputs
                                            name="organizationName"
                                            value={experience.organizationName}
                                            onChange={(e) => handleChange1(index, e)}
                                            label={
                                                errors[`experienceModel[${index}].organizationName`] ? (
                                                    <span className="error-message">
                                                        {errors[`experienceModel[${index}].organizationName`]}
                                                    </span>
                                                ) : (
                                                    t("profile_page.additional_information.Name_of_Work_Place")
                                                )
                                            }
                                            grpClassname={`form-group ${errors[`experienceModel[${index}].organizationName`] ? "form-group-error" : ""
                                                }`}
                                            disabled={!isEditVisible}
                                        />
                                    </Row>
                                </Col>
                                <Col md={3} className="pro-col">
                                    <Row>
                                        <Col className="sd-col">
                                            <fieldset className={`frm-fieldset custom-date-picker ${errors[`experienceModel[${index}].startDate`] ? "error-date" : ""
                                                }`}>
                                                <legend className="frm-legend">

                                                    {errors[`experienceModel[${index}].startDate`] ? (
                                                        <span className="error-message">
                                                            {errors[`experienceModel[${index}].startDate`]}
                                                        </span>
                                                    ) : (
                                                        t("profile_page.additional_information.Start_Date")
                                                    )}
                                                </legend>

                                                <CustomDatePicker.CustomDatePickerDMY
                                                    selected={experience.startDate}
                                                    onChange={(date) =>
                                                        handleDateChange(index, date, "startDate")
                                                    }
                                                    placeholderText="DD - MM - YYYY"
                                                    dateFormat="dd-MM-yyyy"
                                                    className="customDatePicker"
                                                    disabled={!isEditVisible}
                                                />
                                            </fieldset>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col md={3} className="pro-col">
                                    <Row>
                                        <Col className="ed-col">
                                            <fieldset className={`frm-fieldset custom-date-picker ${errors[`experienceModel[${index}].endDate`] ? "error-date" : ""
                                                }`}>
                                                <legend className="frm-legend">

                                                    {errors[`experienceModel[${index}].endDate`] ? (
                                                        <span className="error-message">
                                                            {errors[`experienceModel[${index}].endDate`]}
                                                        </span>
                                                    ) : (
                                                        t("profile_page.additional_information.End_Date")
                                                    )}
                                                </legend>

                                                <CustomDatePicker.CustomDatePickerDMY
                                                    selected={experience.endDate}
                                                    onChange={(date) =>
                                                        handleDateChange(index, date, "endDate")
                                                    }
                                                    placeholderText="DD - MM - YYYY"
                                                    dateFormat="dd-MM-yyyy"
                                                    className="customDatePicker"
                                                    disabled={experience.isStillWorking}
                                                />
                                            </fieldset>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col md={12} className="pro-col">
                                    <Inputs.CheckRadioInput
                                        name="isStillWorking"
                                        checked={experience.isStillWorking}
                                        label={t(
                                            "profile_page.additional_information.Current_Work_Place"
                                        )}
                                        onChange={(e) => handleCheckboxChange(index, e)}
                                        className="form-grp-check"
                                        disabled={!isEditVisible}
                                    />
                                </Col>
                                <Col md={12} className="pro-col">
                                    <Row>
                                        <Inputs.FormInputs
                                            name="description"
                                            value={experience.description}
                                            onChange={(e) => handleChange1(index, e)}
                                            type="textarea"
                                            placeholder={t(
                                                "profile_page.additional_information.Write_text_here"
                                            )}
                                            label={
                                                errors[`experienceModel[${index}].description`] ? (
                                                    <span className="error-message">
                                                        {errors[`experienceModel[${index}].description`]}
                                                    </span>
                                                ) : (
                                                    t("profile_page.additional_information.Write_Short_Description_About_Work_Experience")
                                                )
                                            }
                                            grpClassname={`form-group ${errors[`experienceModel[${index}].description`] ? "form-group-error" : ""
                                                }`}
                                            disabled={!isEditVisible}
                                        />
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    ))}
                    <Col className="pro-col exp-col">
                        <Buttton.Buttton
                            type="button"
                            onClick={addExperience}
                            children={
                                <>
                                    {t("ADD_MORE")} <PiPlus className="add-icon" />
                                </>
                            }
                            className="transparent"
                        />
                    </Col>
                </Row>
            </Form>
            <div className="profile-form-btn-blk">
                <Buttton.Buttton
                    children={t("CANCEL")}
                    className="btn-border-Aqua_Teal"
                />
                <Buttton.Buttton
                    children={t("Send_for_Verification")}
                    className=" btn-solid-Aqua_Teal"
                    onClick={onSendForVerification}
                    disabled={!isEditVisible}
                />
            </div>
        </>
    );
};

export default AdditionalInformation;
